import { render } from "./OrderSalesDetail.vue?vue&type=template&id=9e5a3456"
import script from "./OrderSalesDetail.vue?vue&type=script&lang=js"
export * from "./OrderSalesDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__